export default "__VITE_ASSET__DILNL0Zw__"